const toLocal = state => state.mapView

export const getMapCenter = state => toLocal(state).mapCenter
export const getMapZoom = state => toLocal(state).mapZoom
export const getMapBounds = state => toLocal(state).mapBounds
export const getMapBoundsGeoJSON = state => toLocal(state).mapBoundsGeoJSON
export const getBottomLabel = state => toLocal(state).bottomMapLabel
export const getBottomTitle = state => toLocal(state).bottomMapTitle
